module.exports = __webpack_public_path__ + "img/powered-logo.b5880422.png";